module.exports = __webpack_public_path__ + "static/media/locals_covid.5ec577ad.png";